import styled from 'styled-components';

interface ConfirmModalProps {
  type: string;
  title: string;
  text: string;
  buttonText: string;
  placeholder?: string;
  changeInfo?: string;
  setChangeInfo?: React.Dispatch<React.SetStateAction<string>>;
  onClick: () => void;
  setOpenConfirmModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConfirmModal = ({
  type,
  title,
  text,
  buttonText,
  placeholder,
  changeInfo,
  setChangeInfo,
  onClick,
  setOpenConfirmModal,
}: ConfirmModalProps) => {
  const isConfirmDisabled = changeInfo === '';
  const renderInnerContent = () => {
    if (type === 'confirm') {
      return (
        <Inner>
          <TextBox>
            <Title>{title}</Title>
            <span>{text}</span>
          </TextBox>
          <ApplyButton onClick={onClick}>{buttonText}</ApplyButton>
        </Inner>
      );
    } else {
      return (
        <Inner style={{ width: '420px' }}>
          <TextBox>
            <Title>{title}</Title>
          </TextBox>
          <InputBox>
            <Input
              type="text"
              placeholder={placeholder}
              value={changeInfo ?? ''}
              onChange={(e) => setChangeInfo?.(e.target.value)}
            />
          </InputBox>
          <ButtonBox>
            <CancelButton
              onClick={() => {
                setChangeInfo?.('');
                setOpenConfirmModal?.(false);
              }}
            >
              취소
            </CancelButton>
            <ApplyButton disabled={isConfirmDisabled} onClick={onClick}>
              {buttonText}
            </ApplyButton>
          </ButtonBox>
        </Inner>
      );
    }
  };
  return <Container>{renderInnerContent()}</Container>;
};

export default ConfirmModal;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Inner = styled.div`
  width: 272px;
  padding: 20px 16px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 700;
  color: #171e26;
`;

const TextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
const Title = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;

const ApplyButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: ${({ disabled }) =>
    disabled ? 'rgba(112, 115, 124, 0.08)' : '#008AFF'};
  color: ${({ disabled }) => (disabled ? 'rgba(55, 56, 60, 0.16)' : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;
const CancelButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const InputBox = styled.div`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;
const Input = styled.input`
  border: none;
  background: none;
  flex: 1;
  outline: none;
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
